
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['../constants', './LineAndAreaBaseConfig'], function(constants, BaseConfig) {
	'use strict';
	class Rave2line extends BaseConfig {
		constructor() {
			super();
		}

		_setAreaPropsToInactive(config) {
			config.properties['areas.visible'] = {
				'active': false,
				'defaultValue': false
			};
			config.properties['chart.gradient'] = { 'active': false };
			config.properties['area.borderColor'] = { 'active':false };
			config.properties['area.borderWidth'] = { 'active':false };
			config.properties['area.opacity'] = { 'active':false };
			config.properties['area.opacity.fill'] = { 'active':false };
		}

		_addEffectProperties(config) {
			config.config.include.push(
				'effect.duration',
				'effect.entry.line.type',
				'effect.entry.line.delay',
				'effect.entry.line.stagger',
				'effect.entry.line.duration'
			);
			config['entryDurationProperty'] = 'effect.entry.line.duration';

			config.properties['effect.duration'] = {
				'defaultValue': constants.LONG_EFFECT_DURATION,
				'active': false
			};
			config.properties['effect.entry.line.type'] = {
				'public': false
			};
			config.properties['effect.entry.line.delay'] ={
				'active': false,
				'defaultValue': 0
			};
			config.properties['effect.entry.line.stagger'] = {
				'public': false
			};
			config.properties['effect.entry.line.duration'] = {
				'displayMultiplier': 0.001,
				'public': false,
				'defaultValue': constants.SHORT_EFFECT_DURATION
			};
		}

		get config(){
			const config = super.config;
			config['type'] = 'Line';
			config['supportsForecasts'] = true;
			config.thumbnail.properties['markers.visible'] = true;
			config.properties['markers.shape'] = { 'active':false };
			config.properties['data.handling'] =       {
				active: false,
				defaultValue: 'Simple'
			};

			this._setAreaPropsToInactive(config);
			this._addEffectProperties(config);

			return config;
		}
	}
	return Rave2line;
});
